import React from 'react'

export default props => (
    <button className={`${props.className} keypad-button`} onClick={props.onClick} value={props.value}>
        {props.value}
    </button>
)


// WEBPACK FOOTER //
// ./src/loteria/loteriaKeyPadButton.jsx